enum RewardLimitCalculationType {
    NoLimits = 'NoLimit',
    Quantity = 'Quantity',
    DollarAmount = 'Dollar',
    Both = 'Both',
    PromotionGroup = 'PromotionGroup',
}

export default RewardLimitCalculationType;
